import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  errorMessage!: string;
  error!: {
    error: {
      non_field_errors: Array<string>;
      field_errors: Array<string>;
      message: string;
      error: string;
    };

    status?: number;
    statusText?: string;
    url?: string;
  };
  constructor() {}
  getErrorMessage(error: any): string {

    switch (error.status) {
      case 400:
      case 409:
        if (error.error.non_field_errors) {
          this.errorMessage = error.error.non_field_errors.join();
        } else if (error.error.errors) {
          this.errorMessage = Object.entries(error.error.errors)
            .map((kv) => {
              const [key, value] = kv;
              return [`${key}: ${value}`];
            })
            .join('');
        } else if (error?.error) {
          this.errorMessage = error?.error?.message || error?.error || "An error occurred"
        } else {
          this.errorMessage = error.error;
        }
        break;
      case 500:
        this.errorMessage = 'Internal server error. Please try again later.';
        break;
      case 503:
        this.errorMessage = "Your request could not be processed at this time. Please try again later. Thank you for your patience.";
        break;
      default:
        //do nothing
    }
    return this.errorMessage;
  }
}
